export default __webpack_public_path__ + "static/media/complementos_1.4a00e00f.jpg";